import React from 'react';
import Header from "../../components/Header";
import Question from "../../components/Question";
import Footer from "../../components/Footer";

const Ineligible = ({ handleFooterLinkClick }) => {
  return (
    <div className='wrapper'>
      <Header
        title=''
        heading='Eligibility Checker Result'
      />
      <Question
        heading='Based upon the answers you have given us so far, unfortunately, you are not eligible for the PARTNERS Programme.'
        description='However, if you have experienced personal extenuating circumstances that have affected your studies at key educational times, please contact the <a href="https://www.ncl.ac.uk/partners/help-and-support/contact-us/" target="_blank">PARTNERS Team</a> to discuss this further.<br /><br /><strong>Please note:</strong> The eligibility criteria for PARTNERS are updated annually. Make sure to check your eligibility before submitting your UCAS application.'
      />
      <Footer
        buttonText='Review answers'
        forwardButtonScreen='review'
        changeScreen={handleFooterLinkClick}
      />
    </div>
  )
}

export default Ineligible;